import { ApplicationState } from 'app/fieldapp/store/store'

export const getOtherTimersRequestPending = (
  state: ApplicationState,
): boolean => state.otherTimers.requestPending
